module.exports = __webpack_public_path__ + "/img/Bga-Custom-Footprint-rZuvuV.svg";